import React from "react";
import "../../Assets/Styles/pages/landing.scss";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import LazyLoad from "react-lazyload";

const AddWaterMark = () => {
  const { t } = useTranslation();

  return (
    <Row className="m-0 mt_138 mb_138 pt-3 w-100">
      <Row className="d-flex justify-content-center align-items-center py-1 mb-4 text_40 productSans">
        <Col
          xs={12}
          lg={4}
          className="text-center d-flex justify-content-center align-items-center
                 justify-content-lg-end p-0"
        >
          {t("AddWaterMark")}
        </Col>
        <Col
          xs={12}
          lg={4}
          className="landing_banner_Heading RalewayXBold
                d-flex justify-content-center align-items-center
                justify-content-lg-start m-0 p-0 mx-2 text-center"
        >
          {t("AddWaterMarkSpan")}
        </Col>
      </Row>
      <Row className="m-0 rounded p-0">
        <LazyLoad once>
          <Col className="d-flex justify-content-center h_31_9 yTcontainer">
            {/* <img className="w_70" src={youtubeVideoPlaceHolder} /> */}
            <iframe
              className="youtubeEdgesRound w-50 responsive-iframe"
              src="https://www.youtube.com/embed/tQ7SUuh3gjs"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </Col>
        </LazyLoad>
      </Row>
    </Row>
  );
};

export default AddWaterMark;
